import React from "react";
import MultiBookkeepingList from "./MultiBookkeepingList";
import { MultiModalPickerProps } from "../props";
import MultiModalPickerWithChooseButton from "../MultiModalPickerWithChooseButton";
import SubLabel from "components/Atoms/Sublabel";
import { LabelList } from "../LabelList";


const BookkeepingListItem = bookkeeping => <>
  <div>
    <div>{bookkeeping.name}</div>
    <SubLabel small>{bookkeeping.code}</SubLabel>
  </div>
</>

export const BookkeepingMultiModalPicker = (props: MultiModalPickerProps<server.dto.BookkeepingSmall>) => {
  const { ...rest } = props;

  return <>
    <MultiModalPickerWithChooseButton<server.dto.BookkeepingSmall>
      onNewClicked={() => { }}
      renderLabelContent={BookkeepingListItem}
      getId={(b) => b.bookkeepingId}
      buttonLabel={RESX.Buttons.btnSelect}
      modalTitle={RESX.Bookkeeping.resxBookkeeping}
      modalSize="mini"
      renderModalContent={(editedValue, setEditedValue) => <MultiBookkeepingList
        excludeKeys={editedValue.map(b => b.bookkeepingId)}
        onChange={setEditedValue}
        value={editedValue}
      />}
      {...rest}
    />
  </>;
};

export const SelectedBookkeepings = (props: { value: server.dto.BookkeepingSmall[] }) => {
  return <LabelList
    value={props.value}
    renderLabelContent={BookkeepingListItem}
    getId={(b) => b.bookkeepingId}
  />;
}